import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProcedureRunUIStringForStudyType} from 'studies/TypedStudyUtils';
import {FONT_PROXIMA_14, FONT_WEIGHT_PROXIMA_REGULAR} from 'styles/FontConstants';

import AddExperimentButton from '../utils/ui/AddExperimentButton';

export default function NoExperimentOverview({
  studyId,
  studyType,
  message,
}: {
  studyId: string;
  studyType: StudyType;
  message?: string;
}): JSX.Element {
  const noProcedureRunsMessage =
    message ??
    `Get started by adding ${getProcedureRunUIStringForStudyType(studyType, {includeArticle: true})} to this study`;
  return (
    <div className={css(styles.noExperimentContainer)}>
      <div className={css(styles.noExperimentText)}>{noProcedureRunsMessage}</div>
      <AddExperimentButton studyId={studyId} studyType={studyType} />
    </div>
  );
}

const styles = StyleSheet.create({
  noExperimentContainer: {
    textAlign: 'center',
  },
  noExperimentText: {
    ...FONT_PROXIMA_14,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    textAlign: 'center',
    marginBottom: 24,
  },
});
